import { BasicInput, Button, Panel, Yup } from '@elotech/components';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import { Formik } from 'formik';
import React from 'react';
import Component from 'react-pure-render/component';
import PropTypes from 'prop-types';
import * as types from './Types';

const initialValues = {
  cpfCnpj: '',
  contribuinte: '',
  dataInicial: '',
  dataFinal: ''
};

const validationSchema = tipoMovimentacaoTributo =>
  Yup.object().shape({
    dataInicial: Yup.date()
      .label('Data Inicial')
      .required()
      .test(
        'dataInicial',
        'Data Inicial deve ser menor ou igual a Data Final',
        function (dataInicial) {
          return dataInicial && dataInicial <= this.parent.dataFinal;
        }
      )
      .test(
        'dataInicial',
        'A Data Inicial deve estar dentre os últimos 5 anos com base na data atual',
        function (dataInicial) {
          if (tipoMovimentacaoTributo === types.CADUCIDADE) return true;
          const dataMinima = new Date();
          dataMinima.setFullYear(dataMinima.getFullYear() - 5);
          return (
            dataInicial &&
            new Date(dataInicial).toISOString().split('T')[0] >=
              new Date(dataMinima).toISOString().split('T')[0]
          );
        }
      ),
    dataFinal: Yup.date()
      .label('Data Final')
      .required()
      .test(
        'dataFinal',
        'Data Final deve ser maior ou igual a Data Inicial',
        function (dataFinal) {
          return dataFinal && dataFinal >= this.parent.dataInicial;
        }
      )
      .test(
        'dataFinal',
        'Data Final deve ter menos de 5 anos com base na data atual para a busca de caducidades',
        function (dataFinal) {
          if (tipoMovimentacaoTributo !== types.CADUCIDADE) return true;
          const dataMaxima = new Date();
          dataMaxima.setFullYear(dataMaxima.getFullYear() - 5);
          return (
            dataFinal &&
            new Date(dataFinal).toISOString().split('T')[0] <=
              new Date(dataMaxima).toISOString().split('T')[0]
          );
        }
      )
  });

class RenunciaReceitasForm extends Component {
  static propTypes = {
    search: PropTypes.func.isRequired,
    tipoMovimentacaoTributo: PropTypes.string.isRequired
  };

  render() {
    const { search, tipoMovimentacaoTributo } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={values => search(values)}
        validationSchema={() => validationSchema(tipoMovimentacaoTributo)}
        render={formik => (
          <Panel
            title="Consultar em Renúncia de Receitas"
            mobileClose
            isForm
            expansible
          >
            <BasicInput
              size={2}
              name="cpfCnpj"
              render={({ field }) => (
                <Input
                  type="text"
                  maxLength={14}
                  label="CPF/CNPJ"
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                />
              )}
            />
            <BasicInput
              size={3}
              name="contribuinte"
              render={({ field }) => (
                <Input
                  type="text"
                  label="Nome"
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                />
              )}
            />
            <BasicInput
              size={2}
              name="dataInicial"
              render={({ field }) => (
                <DatePicker
                  label="Data Inicial"
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                />
              )}
            />
            <BasicInput
              size={2}
              name="dataFinal"
              render={({ field }) => (
                <DatePicker
                  label="Data Final"
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                />
              )}
            />
            <div style={{ marginTop: 60 }}>
              <Button
                className="ml-xs inline"
                iconPosition="right"
                color="module-color"
                onClick={formik.submitForm}
              >
                Pesquisar
                <em className="fa fa-search" />
              </Button>
              <Button
                className="ml-xs inline"
                iconPosition="right"
                color="neutral"
                onClick={formik.resetForm}
              >
                Limpar
                <em className="fa fa-times" />
              </Button>
            </div>
          </Panel>
        )}
      />
    );
  }
}

export default RenunciaReceitasForm;
